import cn from "@/util/cn";
import { ComponentPropsWithoutRef } from "react";

const HeaderCell = ({ className, children, ...otherProps }: ComponentPropsWithoutRef<"div">) => (
  <div
    className={cn(
      "flex overflow-visible text-nowrap border-b border-gray-200 py-4 font-semibold text-primary/60",
      className
    )}
    {...otherProps}
  >
    {children}
  </div>
);

export default HeaderCell;
